/**
 * 状态类：status { success、error、warn }
 * 弹窗类：dialog { toast、alert、confirm }
 * 表单类：from { placeholder、label }
 * 表格类：table { }
 *
 * 接口请求类：request
 * 接口响应类：responce
 *
 * 页面模块类：
 *
 */

// 使用 {{$t("purchase.periods")}}  //*ıncı Dönem

// 状态
const state = {
    preheatIng: "Ön Isınma Devam Ediyor",
    purchaseIng: "Satın Alma Devam Ediyor",
    process: "Destek Devam Ediyor",
    over: "Sonlandı",
    finish: "Tamamlandı",
    noData: "Henüz Veri Yok",
};

//Satın Alma Bölgesi ve kişisel satın alma kaydı sayfasının üst kısmındaki alt başlık
const subheader = {
    pricePromise: "Fiyat Garantisi, Asla Dip Yapmaz",
    vipPrice: "VIP İadesi, Fiyat Avantajı",
    protection: "Özel Emtia Bazlı Fiyat Koruması",
    pricePromiseVal: "[*] Gün Fiyat Koruma, Asla Dip Yapmaz",
    rewards: "[*]% Getiri, Fiyat Garantisi",
    vipDis: "VIP İndirimi, Kap Gel Kazan",
    zlz: "Destek Devam Ediyor",
};

// Satın Alma Bölgesi
const purchase = {
    periods: "[*]. Dönem",
    timesSheaves: "[*]. Tur",
    supportPic: "[*] Gün Fiyat Koruma, Asla Dip Yapmaz",
    earnings: "[*]% Getiri, Fiyat Garantisi",
    vipDiscount: "VIP İndirimi, Kap Gel Kazan",
    limit: "Bu Tur Kotası",
    timeLimit: "Sınırlı Süre Fiyatı",
    schedule: "Mevcut İlerleme",
    finishHalf: "[*]% Tamamlandı",
    subscriptionNum: "Satın Alma Miktarı",
    vipText: "(VIP[*]) satın alma ([**] [***] [****] indirim) avantajından yararlanır", //(VIP6) satın alma (2000COINS 5 indirim) avantajından yararlanır
    supportType: "Fiyat Koruma Yöntemi: Fiyat koruma süresi boyunca, BiKing ikincil piyasada en düşük fiyat koruma fiyatından alım emri verecektir. Kullanıcılar fiyat koruma süresi içinde satış yapıp yapmamayı seçebilir. Fiyat koruma süresi sona erdiğinde, ilgili en düşük fiyat koruma alım emirleri iptal edilecektir.",
    beAbouttoAlipay: "Yakında Başlayacak",
    atOnceAlipay: "Hemen Satın Al",
    atOnceAlipayNew: "Hemen Destek Ol",
    atOnceAlipayed: "Zaten satın aldınız, lütfen bir sonraki turu takip edin",
    atOnceAlipayedOver: "Zaten satın aldınız, tekrar satın alamazsınız",
    atOnceAlipayedNew: "Zaten destek oldunuz, lütfen bir sonraki turu takip edin",
    atOnceAlipayedNewOver: "Zaten destek oldunuz, tekrar katılamazsınız",
    website: "Web Sitesi",
    whitePaper: "Beyaz Kitap",
    foreshow: "Satın Alma Ön İzleme",
    startToUp: "Satın Alma Başlasın",
    startToUpNew: "Destek Başlasın",
    distanceStartToUp: "Başlamasına Kalan",
    num: "Şu ana kadar ([*]) kişi satın aldı ([**] BAT)",
    bannerText: "[*] [**] kotasını satın aldı",
    bannerTextNew: "[*] [**] kotasına destek oldu",
    nextProject: "Kotanız tükendi, lütfen bir sonraki projeyi takip edin",
    timesText: "Bu tur tamamen satın alındı, sonraki tur [*]Ay[**]Gün [***]:[****]:[*****] zamanında başlayacak",
    times: "[*] Gün [**] Saat [***] Dakika [****] Saniye",
    viewDetail: "Detayları Görüntüle",
    completePawd: "Hesap İşlem Şifresi Ayarlarını Tamamla",
    sureCoins: "[*] [**]'den fazla hesap bakiyesi olduğundan emin olun (minimum satın alma miktarı)",
    sureBalance: "Hesabınızda [*] bakiyesinin [**]'den büyük olduğundan emin olun",
    set: "Ayarlara Git",
    available: "Satın Alınabilir Kota",
    holding: "Hesap Bakiyesi",
    startSoon: "Satın Alma Yakında Başlayacak",
    startSoonNew: "Destek Yakında Başlayacak",
    projectSupp: "Proje Kotası",
    projectSuppNew: "Destek Üst Sınırı",
    successBuy: "Başarıyla Satın Alındı",
    successBuyNew: "Başarıyla Destek Olundu",
    projectLimit: "Proje Başlangıcına Kalan Süre",
    subscription: "Başarıyla Satın Alındı",
    subscriptionNew: "Başarıyla Destek Olundu",
    projectGoal: "Bu Projenin Toplam Satın Alma Kotası",
    projectGoalNew: "Bu Projenin Destek Kotası",
    goalFunds: "Şu Ana Kadar Tamamlanan Satın Alma",
    goalFundsNew: "Gerçek Destek Hedefe Ulaştı",
};

//Satın Alma Koşulları

const purchaseCondition = {
    q: " ve ",
    h: " veya ",
    cztj: "Yatırım miktarını sağlayın",
    wqyh: "İlgili geçmiş etkinliklere katılmamış kullanıcılarla sınırlıdır",
    vipdj: "VIP[*] ve üzeri VIP seviyesindeki kullanıcılarla sınırlıdır",
    condition: "Satın Alma Koşulu",
    conditionNew: "Destek Koşulu",
    nameverify1: "Çin Anakarası KYC Doğrulamasını Tamamlayın",
    nameverify2: "Çin Anakarası Dışı KYC Doğrulamasını Tamamlayın",
    nameverify3: "BiKing KYC Doğrulamasını Tamamlayın",
    login: "Lütfen Giriş Yapın",
    maxBuyin: "Maksimum Alım",
    verify: "KYC Doğrulamasına Git",
    affirm: "[*]'den fazla hesap bakiyesi olduğundan emin olun",
    myPosition: "Bakiyem",
    AmountOfAscension: "Satın Alma Kotası",
    AmountOfAscensionNew: "Destek Kotası",
    AmountOfAscensionText: "İlk turdan önceki 7 günlük [*] ortalama bakiyeniz ne kadar yüksekse, satın alma kotanız o kadar büyük olur",
    AmountOfAscensionTime: "Önceki 7 Günlük [*] Ortalama Bakiyem",
    discount: "Satın Almada İndirim",
    vip_discount: "Destekte İndirim",
    discountText: "VIP seviyesi ne kadar yüksekse, satın alma fiyatı o kadar düşük olur",
    upgrade: "Yükseltmeye Git",
    vipUpgrade: "VIP'im",
    zled: "Destek Kotası",
    wdzl: "Desteklerim",
    zlxm: "Destek Projesi",
    mlzl: "Tur Başına Destek",
    zlmx: "Destek Detayları",
    ccff: "İlk Dağıtım",
    qgmx: "Satın Alma Detayları",

    fjtj: "Ek Koşul",
    guoji: "Uyruk",
    noJoin: "Katılım Desteklenmiyor",
    wancheng: "Tamamla",
    pinggu: "《Dijital Para Yatırım Risk Değerlendirme Formu》",
    cyhd: "Etkinliğe Katıl",
};

// Geçmiş Projeler
const historyProject = {
    rushLimit: "Satın Alma Kotası",
    averagePic: "Ortalama Fiyat",
    averageNum: "Satın Alan Kişi Sayısı",
};

// Ödeme
const alipay = {
    alipaynum: "Satın Alma Miktarı",
    alipaynumNew: "Destek Kotası",
    ShouldPay: "Ödenecek Tutar",
    VipDiscounts: "VIP İndirimi",
    VipWin: "win üye indirimi",
    willOpen: "Yakında Açılacak",
    actualPayment: "Gerçek Ödeme",
    actualPaymentNew: "Bu Tur Destek",
    importPassword: "Lütfen İşlem Şifrenizi Girin",
    forGetPassword: "İşlem Şifrenizi mi Unuttunuz?",
    promptlyAlipay: "Hemen Öde",
    purchaseSuccess: "Tebrikler, satın alma başarılı",
    purchaseSuccessNew: "Tebrikler, destek başarılı",
    purchaseError: "Maalesef, satın alma başarısız, lütfen sayfayı yenileyip tekrar deneyin",
};
// Proje Detayları
const projectDetails = {
    text: "[*][**]'den fazla hesap bakiyesi olduğundan emin olun",
    timelimitPic: "Sınırlı Süre Fiyatı",
    subscriptionLimit: "Satın Alma Kotası",
    subscriptionLimitNew: "Destek Kotası",
    preheat: "Ön Isınma",
    supportAbort: "Fiyat Koruma Bitişi",
    unlockAbort: "Dağıtım Zamanı",
    projectIntroduction: "Proje Tanıtımı",
    projectRole: "Etkinlik Kuralları",
    rule: "Satın Alma Kuralları",
    ruleNew: "Destek Kuralları",
};
// Satın Alma Sonrası
const purchaseOver = {
    haveSubscribed: "Satın Alınan Kota",
    schedule: "Mevcut İlerleme",
    Stime: "Satın Alma Başlangıç Zamanı",
    StimeNew: "Destek Başlangıç Zamanı",
    Etime: "Satın Alma Bitiş Zamanı",
    EtimeNew: "Destek Bitiş Zamanı",
    successText: "Bu projenin fon toplama kotası [*] BAT, gerçek fon toplama fon hedefine ulaştı, fon toplama başarılı!",
    success: "Başarılı",
};
// Satın Almalarım
const myPurchase = {
    endUnlock: "Son Tur Satın Alma Bitişinde Dağıtılacak",
    endUnlock2: "Son Tur Satın Alma Bitişinde Dağıtılacak",
    LText: "Fiyat koruma süresince günlük dağıtım",
    WText: "Fiyat koruma süresi dışında günlük dağıtım",
    unlockend: "Dağıtıldı",
    record: "Satın Alma Detayları",
    myPurchaseName: "Katıldığım Projeler",
};

//mHeader
const mHeader = {
    sy: "Ana Sayfa",
    ksjy: "Hızlı İşlem",
    zyjy: "Profesyonel İşlem",
    c2c: "C2C İşlem",
    otc: "OTC İşlem",
    zczx: "Varlık Merkezi",
    xwgg: "Haber Duyuruları",
    xwgg1: "Duyuru",
    lc: "BiKing Earn",
    gxlc: "Yüksek Faizli Yatırım",
    dxjh: "FansUp!",
    fbjy: "Coin Satın Al",
    dl: "Giriş Yap",
    zc: "Kayıt Ol",
    jtzw: "Basitleştirilmiş Çince",
    ftzw: "Geleneksel Çince",
    english: "English",
    kr: "한국어",
    qgms: "Anında Satın Alma",
    xsjy: "Potansiyel İşlem",
    // Kalan uluslararasılaştırma
    zczgz: "Toplam Varlık Değerlemesi",
    yhzx: "Kullanıcı Merkezi",
    wdgl: "Emir Yönetimi",
    tc: "Hesaptan Çıkış",
    dltq: "Düşük İşlem Hacimli Bölge",
    sdgm: "Anında Satın Al",

    // app indir
    appdown: "APP İndir",
    appdown1: "İndir",
    biking: "BiKing APP",
    gfqb: "Resmi Cüzdan",
    xzbyapp: "BiKing APP'i İndir",
    xzbyapp2: "BiKing APP'i İndir",
    smewm: "QR Kodu Tara",
    xzhyqb: "HyperPay Cüzdanını İndir",
    xzhyqb2: "HyperPay Cüzdanını İndir",
    bbjy: "Coin-Coin İşlem",
    hyjy: "Vadeli İşlem Sözleşmesi", //"Vadeli İşlem",
    eftjy: "ETF İşlem",
    byb: "Coin Kazan",
    newPos: "HBT Madencilik Havuzu",
    HyperPay: "HyperPay ile Coin Kazan",
    hqlc: "POS Madenciliği",
    newlc: "Coin Kazan",

    // Yeni header
    dd: "Sipariş",
    zichan: "Varlık",
    xxzx: "Mesaj Merkezi",
    zhyaq: "Hesap & Güvenlik",
    sfyz: "Kimlik Doğrulama",
    wdvip: "VIP'im",
    apigl: "API Yönetimi",
    hdzx: "Etkinlik Merkezi",
    wdhb: "Kırmızı Zarflarım",
    flzx: "Yarar Merkezi",
    bitloan: "Coin Kredi",
    ggjy: "Kaldıraçlı İşlem",
    hyxy: "Akademi",
    flhd: "Yarar Etkinlikleri",
    bitWin: "BiKing Hazinesi",
};
//progress
const mProgress = {
    dqjd: "Mevcut İlerleme",
    yjs: "Dağıtıldı",
};

//res
const res = {
    //Satın alma hata mesajı
    seckill_project_000: "Sistem hatası",
    seckill_project_001: "Kullanılabilir proje yok",
    seckill_project_002: "Proje bilgisi mevcut değil",
    // Kullanıcı bilgisi hata mesajı
    seckill_userInfo_001: "Kullanıcı mevcut değil",
    //i18n hata mesajı
    i18n_no_table_001: "Sistem meşgul",
    //Satın alma kaydı
    seckill_record_1: "Ödeme başarısız",
    //7 günlük bakiye kuralı
    seckill_7days_1: "Mevcut proje altında bakiye kuralı bulunamadı",
    //Cüzdan ile ilgili
    seckill_wallet_1: "Sistem meşgul",
    seckill_wallet_2: "Cüzdan bakiyesi yetersiz",
    seckill_wallet_3: "Ödeme başarısız",
    //Proje istatistiği
    seckill_record_count_1: "Veri hatası",
    seckill_record_count_2: "Ödeme başarısız",
    seckill_record_count_3: "Ödeme başarısız",
    //Proje turları
    seckill_rounds_1: "Sistem meşgul",
    seckill_rounds_2: "Mevcut projede, satın alma aşamasındaki tur bulunamadı",
    seckill_rounds_3: "Mevcut projede, tur bilgisi bulunamadı",
    seckill_rounds_4: "Sistem meşgul",
    seckill_rounds_5: "Mevcut projede, belirtilen tur bilgisi bulunamadı",
    //Proje bilgisi
    seckill_pro_1: "Proje bilgisi bulunamadı",
    seckill_pro_2: "Satın alma kotası minimum satın alma miktarından küçük",
    seckill_pro_4: "Sistem meşgul",
    seckill_pro_5: "Proje yayında durumunda değil",
    //Ödeme
    seckill_pay_1: "Sistem meşgul",
    seckill_pay_2: "Sistem meşgul",
    seckill_pay_3: "Proje bilgisi bulunamadı",
    seckill_pay_4: "Satın alma kotası minimum satın alma miktarından küçük",
    seckill_pay_5: "Satın alma kotası bu tur kalan kotayı aşıyor",
    seckill_pay_6: "Satın alma kotası yok",
    seckill_pay_7: "Satın alma miktarı satın alma kotasından büyük",
    seckill_pay_8: "Sistem meşgul",
    seckill_pay_9: "İşlem şifresi hatalı",
    seckill_pay_10: "Ödeme başarısız, lütfen tekrar satın alın",
    seckill_pay_11: "Ödeme başarısız, lütfen tekrar satın alın",
    seckill_pay_12: "Kullanıcı bilgisi hatalı",
    seckill_pay_13: "Ödeme başarısız",
    seckill_pay_14: "İşlem şifresi hatalı",
    seckill_pay_15: "Sistem meşgul",
    seckill_pay_16: "Tamamen satın alındı",
    seckill_pay_17: "Maalesef, şu anda sırada bekleyen satın alma sayısı çok fazla, lütfen tekrar deneyin",
    seckill_pay_18: "Bu turda zaten satın alındı",
    seckill_pay_19: "Bu tur tamamen satın alındı",
    seckill_pay_20: "Lütfen önce giriş yapın",
    seckill_pay_21: "Lütfen önce kimlik doğrulamasını tamamlayın",
    seckill_pay_22: "Bu proje sadece Çin Anakarası KYC kullanıcılarına açıktır",
    seckill_pay_23: "Bu proje sadece Çin Anakarası dışı KYC kullanıcılarına açıktır",
    seckill_pay_24: "İşlem şifresi hatalı giriş sınırı aşıldı, lütfen daha sonra tekrar deneyin",
    seckill_hold_1: "Sahip olduğunuz [*] miktarı katılım koşulunu karşılamıyor, lütfen satın aldıktan sonra tekrar katılın",
    // Anket
    seckill_survey_submited: "Bu anketi zaten gönderdiniz",
    seckill_survey_error: "Anket bilgisi işlenirken hata oluştu",
    seckill_survey_info: "Mevcut proje altında, bu anket bilgisi bulunamadı",
};

const addContent = {
    hdjshy: 'Etkinlik bitimine kalan süre',
    qgsj: "Satın Alma Zamanı",
    qgsjNew: "Destek Zamanı",
    gz: "Kural",
    zdjg: "En Düşük Fiyat",
    sq: "Daralt",
    qgms: "Anında Satın Alma",
    rgxm: "Katılım Projesi",
    bled: "Bu Tur Kotası",
    dqjd: "Mevcut İlerleme",
    yjs: "Dağıtıldı",
    yff: "Dağıtıldı",
    qbcc: "Bakiye Tut",
    cg: "Aş",
    jxmks: "Proje Başlangıcına Kalan Süre",
    ycgrg: "Başarıyla Satın Alındı",
    cgrg: "Başarılı Satın Alma",
    xmed: "Proje Kotası",
    cxmck: "Bu Projenin Fon Toplama Kotası",
    ckmb: "Gerçek Fon Toplama Fon Hedefine Ulaştı",
    ck: "Fon Toplama",
    ckxq: "Detayları Görüntüle",
    kqed: "Satın Alınabilir Kota",
    zhcc: "Hesap Bakiyesi",
    jjks: "Satın Alma Yakında Başlayacak",
    mmsz: "Hesap İşlem Şifresi Ayarlarını Tamamla",
    qsz: "Ayarlara Git",
    qbye: "Hesabınızda [*] bakiyesinin [**]'den büyük olduğundan emin olun",
    zjcz: "[*] [**]'den fazla hesap bakiyesi olduğundan emin olun (minimum satın alma miktarı)",
    jgdb: "Fiyat Garantisi, Asla Dip Yapmaz",
    jgyh: "VIP İadesi, Fiyat Avantajı",
    bwbj: "Özel Emtia Bazlı Fiyat Koruması",
    bj: "[*] Gün Fiyat Koruma, Asla Dip Yapmaz",
    sybj: "[*]% Getiri, Fiyat Garantisi",
    zk: "VIP İndirimi, Kap Gel Kazan",
    r: "kişi",
    lsxm: "Geçmiş Projeler",
    // bpf: "15 gün dip yapmaz, yukarı çıkabilir aşağı inemez",
    bpf: "Topluluk Desteği, Bol Çeşit Yarar Dalgası Geliyor",
    // syybz: "Getiri garantili, çıkışta indirim",
    syybz: "Düşük katılım eşiği, yararları herkesle paylaş",
    // hg: "VIP'lere geri ödeme, büyük satın alma indirimi",
    hg: "VIP üye olun, daha fazla yarardan yararlanın",
    zgkx: "[*] [**]'a kadar indirim",
    vip_zgkx: "VIP seviyesi ne kadar yüksekse, satın alma toplam fiyatında o kadar fazla indirim olur. Maksimum VIP6 [*][**] avantajından yararlanır",
    vip_zgkxNew: "VIP seviyesi ne kadar yüksekse, destek toplamında o kadar fazla indirim olur. Maksimum VIP6 [*][**] avantajından yararlanır",
    blsysj: "Bu Tur Kalan Süre",
    blqbqw: "Bu Tur Tamamen Satın Alındı",
    xyl: "Sonraki Tur",
    zskq: "Zamanında Başlasın",
    bljshs: "Bu Tur Satın Alma Bitişine Kalan Süre",
    zqyc: "Her turda sadece bir kez satın alma yapabilirsiniz, lütfen bir sonraki turda tekrar deneyin!",
    zxkf: "Bu etkinliğe katılım izniniz yok. Daha fazla bilgi için müşteri hizmetlerine danışın",
    zqycNew: "Her turda sadece bir kez destek olabilirsiniz, lütfen bir sonraki turda tekrar deneyin!",
    wed: "Bu projede satın alınabilir kotanız 0, lütfen bir sonraki projeyi takip edin",
    wedNew: "Bu projede destek olunabilir kotanız 0, lütfen bir sonraki projeyi takip edin",
    zsqg: "Minimum satın alma kotası [*][**], lütfen bakiye ekledikten sonra satın alın",
    srmm: "Lütfen İşlem Şifrenizi Girin",
    smrz: "Lütfen önce KYC kimlik doğrulamasını tamamlayın",
    qszjymm: "Lütfen önce işlem şifresi ayarlarına gidin",
    wenjuandiaocha: "Bu etkinliğe katılmak için önce anketi tamamlamanız gerekiyor.",
    scqgms: "BiKing Hayran Şenliği",
    // scqgms: "Özgün Fiyat Koruma Modeli",
    // hxyh: "Sınırlı süre taban getiri, VIP'ler için daha fazla indirim",
    hxyh: "BiKing Topluluğuna destek olun, çeşit çeşit yararların keyfini çıkarın",
    zsqged: "Minimum Satın Alma Kotası [*] [**]",
    zsqgedNew: "Minimum Destek Kotası [*] [**]",
    wmtj: "Sahip olduğunuz [**] miktarı katılım koşulunu karşılamıyor, lütfen satın aldıktan sonra tekrar katılın",
    qjchqg: "Lütfen bakiye ekledikten sonra satın alın",
    qjchqgNew: "Lütfen bakiye ekledikten sonra destek olun",
    rgjg: "Satın Alma Fiyatı",
    qqg: "İndirimi Kap",
    wdqgjl: "Katılım Kaydım",
    ckxmxq: "Proje Detaylarını Görüntüle",
    t: "gün",
    yr: "[*]Ay[**]Gün",
    yrz: "[*]. Tur Ön Isınmada",
    qgz: "[*]. Tur Satın Almada",
    djlyjs: "[*]. Tur Sona Erdi",
    dj: "VIP Seviyesi",
    xszk: "İndirim Oranı",
    jgzked: "Katılım İndirim Kotası",
    zked: "İndirim Kotası",
    edw: "Kota dışı normal fiyatla ödeme yapılır",
    qbcczd: "1000CWT'den fazla hesap bakiyesi olduğundan emin olun (minimum satın alma miktarı)",
    qrrjcc: "7 Günlük Ortalama Bakiye",
    jlblks: "Bu Tur Başlangıcına Kalan Süre",
    jlbljs: "Bu Tur Bitişine Kalan Süre",
    zgkqed: "Maksimum Satın Alınabilir Kota",
    zgkzf: "Maksimum Ödenebilir Tutar",
    cggmsl: "Girdiğiniz satın alma miktarı, satın alma limitinizi aşıyor",
    bzzfzxgm: "Mevcut bakiye minimum satın alma miktarını ödemek için yetersiz",
    bqzdqg: "Minimum satın alma kotası [*] [**]",
    zlzcLower: "Minimum destek kotası [*], maksimum destek kotası [**]. Etkinlik sona erdikten sonra destekle kazanılan tokenler 5 iş günü içinde hesabınıza dağıtılacaktır.",
    zgqged: "Maksimum kota [*] [**]",
    yzbz: "Kaliteli tokenler için sınırlı süreli hayranlara özel indirim",
    xszkj: "Sınırlı Süreli İndirimli Fiyat",
    zlbxsq: "Ana Akım Tokenler için Sınırlı Süreli Satın Alma",
    wks: "Başlamadı",
    jxz: "Devam Ediyor",
    qgsl: "Satın Alma Miktarı",
    wcydxm: "Katıldığım Projeler",
    bjq: "Fiyatlandırma Dönemi",
    hgq: "Geri Alma Dönemi",
    qzk: "İndirimi Kap",
    qxzl: "Önce Destek Ol Token Kazan",
    ds: "Destek Üst Sınırı",
    dhbl: "Dönüşüm Oranı",
    jicj: "Taban Fiyat",
    jiagzd: "Nihai fiyat, satın alma başlamadan önceki 3 saat içinde belirlenir",
    zdyh: "Maksimum İndirim",
};

const hyy = {
    bkt: "Açma",
    wqdkt: "Açmayı Onaylıyorum",
    kt12: "1.	Katılım öncesinde, dijital para vadeli işlem sözleşmelerinin temel bilgilerini ve ilgili riskleri ile türev enstrüman işlemleriyle ilgili tüm iş kurallarını ayrıntılı bir şekilde öğrenmelisiniz.",
    kt13: "2.	Bu risk bildirimi metninde yer alan risk maddeleri sadece örnek niteliğindedir ve dijital varlık türev enstrüman işlemleriyle ilgili tüm risk faktörlerini kapsamamaktadır. Yatırımcılar, dijital varlık türev enstrüman işlemlerine katılmadan önce, diğer olası risk faktörlerini de anlamalı ve öğrenmelidir.",
    kt14: "3.	Yatırımcılara, risk toleransları ve kendi gerçek durumlarından yola çıkarak, bu vadeli işlem sözleşmesi işlemlerine katılıp katılmama konusunda dikkatli karar vermelerini ve dijital varlıklarını makul bir şekilde yapılandırmalarını içtenlikle tavsiye ve umut ediyoruz.",
    kt0: "Sayın Kullanıcı:",
    kt1: "Vadeli işlem hesabınız ve vadeli işlem işlem izniniz henüz açılmamış. Lütfen aşağıdaki içeriği dikkatlice okuduktan sonra açıp açmamaya karar verin:",
    kt2: "1.	Vadeli işlem piyasasında işlem yaparken, piyasa fiyat hareketleri sizin aleyhinize olduğunda ve pozisyon teminatınız yetersiz kaldığında, BiKing Vadeli İşlem Sözleşmeleri, sistem anlaşmasına göre pozisyonunuzu zorla kapatacak ve kapatma detaylarını açıklayacaktır.",
    kt3: "2.	BiKing Vadeli İşlem Sözleşmeleri'nin iş kurallarını dikkatlice okumalı ve bunlara uymalı, sözleşmenin mekanizmasını ve işleyiş prensiplerini anlamalı ve piyasadaki çeşitli riskleri bilmelisiniz.",
    kt4: "4.	BiKing Vadeli İşlem Sözleşmeleri, vadeli işlem işlem sistemine bağlıdır. Kullanıcı pozisyonlarının kar/zararı, vadeli işlem piyasa dalgalanmalarına göre değişir. Büyük kayıplarda, vadeli işlem işlem sisteminde de zorunlu kapatma meydana gelebilir. Lütfen kullanıcılar, vadeli işlem piyasa durumuna göre kendi işlem davranışlarını zamanında kendi kararlarıyla yapsınlar, kar/zarar kendilerine aittir. Buna göre, BiKing herhangi bir varsayılan veya belirlenmiş garanti sorumluluğu üstlenmez.",
    kt5: "5.	Bazı aşırı piyasa koşullarında, elinizdeki açık pozisyonları kapatmak zor veya imkansız olabilir. Örneğin, karınız tüm vadeli işlem piyasasında efektif kaldıraç PnL'sinde birinci sırada yer aldığında ve karşı tarafın sigorta fonu, zararını karşılamaya yetmediğinde.",
    kt6: "6.	Dijital varlık türev enstrüman işlemleri, belirli yargı bölgelerinde politika düzenleme riskleriyle karşılaşabilir. İşlem yapmadan önce, işlem bölgesinin politika düzenleme arka planını anlayarak dikkatli bir şekilde karar vermelisiniz. İlgili ülke ve bölgelerin kanunları, yönetmelikleri, politikalarındaki değişiklikler, vadeli işlem borsası işlem kurallarındaki değişiklikler, acil önlemlerin çıkması vb. nedenlerle BiKing önceden açıklama yapacaktır. Elinizdeki açık pozisyonlar tutulamayabilir, ancak teminat ve kar bakiyeleri yine de ödenecektir.",
    kt7: "7.	Platform tarafından kontrol edilemeyen nedenlerden dolayı, örneğin: deprem, sel, yangın gibi mücbir sebep halleri veya bilgisayar sistemi, iletişim sistemi arızaları gibi, emirlerinizin işleme alınamamasına veya tamamen işleme alınamamasına neden olabilir. Bu nedenle oluşan kayıplar kendiniz tarafından karşılanabilir.",
    kt8: "8.	 “Riskten korunma” işlemleri de spekülatif işlemler gibi fiyat dalgalanmalarından kaynaklanan risklerle karşı karşıyadır.",
    kta9: "9.	Kimlik doğrulaması yapmadıysanız veya Google Doğrulayıcı bağlamadıysanız veya hesabınızı kendiniz dışında birine devrettiyseniz, vadeli işlem teminatınızın güvenliği etkilenebilir",
    kta10: "3.  Bazı aşırı piyasa koşullarında, elinizdeki açık pozisyonları kapatmak zor veya imkansız olabilir. Örneğin, karınız tüm vadeli işlem piyasasında efektif kaldıraç PnL'sinde birinci sırada yer aldığında ve karşı tarafın sigorta fonu, zararını karşılamaya yetmediğinde.",
    kt9: "Dikkatlice okudum ve riski üstlenmeyi kabul ediyorum",
    kt10: "Vadeli işlem hesabını ve vadeli işlem işlem iznini aç",
    zjhz: "Fon Transferi",
    ljhz: "Hemen Transfer Et",
    qx: "Transferi İptal Et",
    khz: "Transfer Edilebilir",
    qxz: "Lütfen Seçin",
    bz: "Token",
    c: "Kimden",
    zz: "Kime",
    sl: "Miktar",
    qb: "Tümü",
    ktcg: "Açma Başarılı",
    ktsb: "Açma Başarısız",
    hzcg: "Transfer Başarılı",
    hzsb: "Transfer Başarısız",
    wyyd: "", //Okundu onaylanmadı uyarı metni
    tc: "Çıkış",
    warning1: "Lütfen bir token seçin",
    warning2: "Gönderen hesap boş olamaz",
    warning3: "Alıcı hesap boş olamaz",
    warning4: "Lütfen transfer edilebilir miktardan büyük olmayan bir sayı girin",
    gb: "Kapat",
    openSuccess: "Vadeli işlem işlemlerini açtınız",
    openSuccessTip: "Lütfen vadeli işlem hesabına fon transfer edin",
    warning5: "Maksimum 4 ondalık basamak",
    not_get_nm: "Maalesef, çamur kodu etkinliği sona erdi, bu transfer çamur kodu kazanamadı",
};

const trading = {
    gflj: 'Resmi Bağlantı',
    gw: 'Resmi Web Sitesi',
    qkllq: 'Blok Gezgini',
    scfxsj: 'İlk Çıkış Zamanı',
    fxzl: 'Toplam Arz',
    ltzl: 'Dolaşımdaki Arz',
    jy: 'İşlem',
    sj: 'Piyasa Fiyatı',
    tbxx: 'Grafik Bilgisi',
    bzgk: 'Token Genel Bakış',
    ddb: 'Emir Defteri',
    zxcj: 'Son İşlemler',

    reload: "Yenile",
    socketError: "Ağ hatası, lütfen",
    noData: "Henüz Veri Yok",
    entrustorder: "Emir Defteri",
    prices: "Fiyat",
    quantity: "Miktar",
    grandtotal: "Toplam",
    transamount: "İşlem Hacmi",
    time: "Zaman",
    available: "Kullanılabilir",
    limitorder: "Limit",
    plancommission: "Planlı Emir",
    currentcommission: "Açık Emir",
    historycommission: "Emir Geçmişi",
    completecommission: "Gerçekleşen Emirler",
    funds: 'Fonlar',
    hidetrading: "Diğer İşlem Çiftlerini Gizle",
    morecurrentcommission: "Daha Fazla Açık Emir",
    morehistorycommission: "Daha Fazla Emir Geçmişi",
    moredocommission: "Daha Fazla Gerçekleşen Emir",
    realtimetrans: "Gerçek Zamanlı İşlemler",
    myassets: "Varlıklarım",
    detail: "Detay",
    buyin: "Al",
    sellout: "Sat",
    login: "Giriş Yap",
    transfer: "Transfer",
    recharge: "Yatırma",
    withdrawal: "Coin Satın Al",
    quickpurchase: "Hızlı Coin Satın Alma",
    default: "Varsayılan",
    ordertime: "Emir Zamanı",
    tradingpair: "İşlem Çifti",
    direction: "Yön",
    types: "Tür",
    commissionprice: "Emir Fiyatı",
    commissionnumber: "Emir Miktarı",
    dealprice: "Ortalama İşlem Fiyatı",
    dealnumber: "İşlem Miktarı",
    triggerprice: "Tetikleyici Fiyat",
    cancelall: "Tümünü İptal Et",
    averageprice: "Ortalama Fiyat",
    totalsum: "Toplam",
    fixedprice: "Limit",
    marketprice: "Piyasa",
    codeExpired: "QR kodu süresi doldu",
    clickRefresh: "Yenilemek için tıklayın",
    QRsuccessfully: "QR kod tarama başarılı",
    loginInApp: "Lütfen uygulama içinde girişi onaylayın",
    backtoQR: "QR kod girişine dön",
    loginSuccess: "Giriş başarılı, biking hoş geldiniz!",
    loadingText: "Yükleniyor...",
    searchPlaceholder: "Ara",
    all: "Tümü",
    currency: "Token",
    price: "Son Fiyat",
    market: "Yükselenler",
    increase: "Değişim",
    highestPrice: "En Yüksek",
    minimumPrice: "En Düşük",
    turnover: "İşlem Hacmi",
    jydlb: "İşlem Çifti Listesi",
    bzjs: "Token Tanıtımı",
    currencyTransaction: "Coin-Coin İşlem",
    leveragedTransaction: "Kaldıraçlı İşlem",
    warning: "Risk uyarısı: Bitcoin Cash fork son derece belirsizlik içerir. Fork vadeli tokenlerini işlemek veya yatırım yapmak son derece risklidir. Eğer bir zincir madenci desteğinden yoksunsa, devam etme olasılığı düşüktür ve ilgili tokenlerin değeri sıfırlanma riski taşır. BiKing herhangi bir fork vadeli tokeninin değeri için herhangi bir taahhütte bulunmaz!",
    zb: "Gösterge",
    date: "Zaman",
    UpAnddown: "Fark",
    amplitude: "Oynama",
    0: "Anlık",
    1: "1 Dakika",
    5: "5 Dakika",
    15: "15 Dakika",
    30: "30 Dakika",
    60: "1 Saat",
    240: "4 Saat",
    3600: "1 Gün",
    10800: "1 Hafta",
    dates: "Periyot:",
    password: "İşlem Şifresi",
    errorPassword: "Lütfen doğru işlem şifresini girin",
    worningPassword: "Lütfen işlem şifresini girin",
    cancel: "İptal",
    sure: "Onayla",
    canBuy: "Alınabilir",
    canCell: "Satılabilir",
    withdraw: "Çekme",
    otc: "OTC, hızlı para yatırma ve çekme",
    enterPrice: "Lütfen fiyat girin",
    sellingPrice: "Satış Fiyatı",
    purchasePrice: "Alış Fiyatı",
    salesVolume: "Satış Hacmi",
    buyingVolume: "Alım Hacmi",
    volume: "İşlem Hacmi",
    serviceCharge: "İşlem Ücreti",
    vip: "VIP'yi Yükselt, İşlem Ücretlerinde Hemen İndirim Kazan",
    or: "veya",
    register: "Kayıt Ol",
    totalPrice: "İşlem hacmi şundan büyük olamaz",
    amountTip: "Lütfen doğru miktarı girin",
    amountTipError: "Miktar şundan büyük olamaz",
    limitTrading: "Limit İşlem",
    priceReminder: "Fiyat Hatırlatıcı",
    SMSReminder: "SMS Hatırlatıcı",
    loginAccount: "Hesaba Giriş",
    phone: "Telefon",
    phoneNum: "Lütfen telefon numarasını girin",
    phoneTips: "Lütfen doğru telefon numarasını girin",
    email: "E-posta",
    emailNum: "Lütfen e-posta adresini girin",
    emailTips: "Lütfen doğru e-posta adresini girin",
    aears: "Lütfen alan kodunu seçin",
    passwordError: "Lütfen doğru şifreyi girin",
    passwordTips: "Lütfen şifreyi girin",
    forgetPassword: "Şifremi Unuttum",
    noAccount: "Hesabınız yok mu?",
    goRegister: "Hemen Kayıt Ol",
    appsys: "APP QR kod tarama ile güvenli giriş",
    xzapp: "En Son APP'i İndir",
    mmdl: "Şifre ile Giriş",
    smdl: "QR Kod ile Giriş",
    google: "Google Doğrulayıcı",
    nybd: "Zaten bağladınız",
    zqyzm: "Lütfen doğru doğrulama kodunu girin",
    fsyzm: "Doğrulama Kodu Gönder",
    flv: "Oran",
    jz: "Net Değer",
    jzdesc1: "Long Net Değer = Bir önceki ayarlama noktasındaki net değer * [1+3*(Spot son işlem fiyatı - Spot bir önceki ayarlama noktası fiyatı)/Spot bir önceki ayarlama noktası fiyatı*100%];",
    jzdesc2: "Short Net Değer = Bir önceki ayarlama noktasındaki net değer * [1-3*(Spot son işlem fiyatı - Spot bir önceki ayarlama noktası fiyatı)/Spot bir önceki ayarlama noktası fiyatı*100%];",
    sbd: "3x Long",
    sbs: "3x Short",
    flvjs: "ETF fon oranı, platformun fon kombinasyonunun ürettiği fon oranını ödemek için her gün kaldıraca karşılık gelen oranda yönetim ücreti almasıdır. Yönetim ücreti net değer değişiminde yansıtılır, yani 'ilgili kaldıraçlı ETF'nin değerinin düşürülmesi' şeklinde gösterilir ve sadece Singapur saatiyle 00:00'da alınır. Eğer ürün bu saatte elde tutulmuyorsa ücret oluşmaz.",
    mzsm: "Sorumluluk Reddi",
    ido: "Okudum ve kabul ediyorum",
    exemption1: "Sayın Müşteri, merhaba!",
    exemption2: "BiKing platformuna (BiKing.ai) giriş yaptığınız ve sunduğu kaldıraçlı ETF ürünleri ve ilgili hizmetlerden (bundan böyle “ETF Ürünleri” olarak anılacaktır) yararlandığınız için teşekkür ederiz. Lütfen ETF ürün açıklamasını ve aşağıdaki risk uyarılarını dikkatlice okuyunuz. Okuduktan sonra ETF Ürünlerini kullanmaya devam etmeniz, ETF Ürünlerinin risklerini tamamen anladığınızı ve kavradığınızı, ETF Ürünlerinin kullanımının getirebileceği kayıpları karşılayabileceğinizi ve bu sorumluluk reddinin tüm içeriğini kabul ettiğinizi gösterir. Lütfen ETF ürün açıklamasını okumak için tıklayın:",
    exemption3: "《Kaldıraçlı ETF Ürünleri SSS》",
    exemption4: "Risk uyarısı:",
    exemption5: "1. Satın aldığınız/sattığınız fiyat, birim net değerinden büyük bir sapma göstermemelidir, aksi takdirde karşılık gelen kayıplara uğrayabilirsiniz.",
    exemption6: "2. Yön tahmini yanlışsa, aşırı piyasa koşullarında fiyatın sıfıra yaklaşma riski vardır.",
    exemption7: "BiKing platformu, yukarıdaki risklerden kaynaklanan kayıp veya sorumlulukların tamamının size ait olduğunu ve BiKing platformunun bu konuda herhangi bir sorumluluk kabul etmediğini size önemle hatırlatır. Bu sorumluluk reddi, BiKing platformu içindeki diğer anlaşmalar, beyanlar, kurallar vb. ile birlikte, BiKing platformunun hizmet ve ürünleri ile ilgili olarak BiKing platformu ile sizin aranızda varılan tam mutabakatı oluşturur.",
    bzjs1: "1、“3L” temel işlem çiftinin fiyatının %1 yükselmesi durumunda, bu ürünün net değerinin %3 yükseleceği anlamına gelir",
    bzjs2: "2、“3S” temel işlem çiftinin fiyatının %1 düşmesi durumunda, bu ürünün net değerinin %3 yükseleceği anlamına gelir",
    bzjs3: "3、Net değer normalde her gün 00:00'da ayarlanır, aşırı piyasa koşullarında seans içinde ayarlanabilir",
    bzjs4: "4、Her kaldıraç katı için günlük olarak ilgili yönetim ücreti alınacaktır",
    bzjs5: "5、İşlem yapmadan önce lütfen net değeri kontrol edin. Bu ürün aşırı piyasa koşullarında fiyatın sıfıra yaklaşma ve fiyatın net değerden çok sapma riski taşır, yatırımcılar risk kontrolüne dikkat etmelidir",
    gdjk: "Daha fazla detay için lütfen duyuruyu kontrol edin",
    firstTrading: "İlk işlemden önce, lütfen önce işlem şifresini ayarlayın",
    status: "Durum",
    status1: "Eşleşmeyi Bekliyor",
    status2: "İşleme Alınmadı",
    status3: "Kullanıcı Tarafından İptal Edildi",
    status4: "Kısmen İşleme Alındı",
    status5: "Tamamen İşleme Alındı",
    status6: "Geçersiz",
    allCancel: "Tüm Açık Emirleri Toplu İptal Et",
    canceld: "Emri İptal Et",
    cancelsuccess: "Tüm emirler başarıyla iptal edildi, [*] emir iptal edildi",
    VIP1: "Seviyeniz VIP",
    VIP2: "Daha düşük işlem ücretleri, daha kaliteli işlem deneyimi",
    VIP3: "Taker (Piyasa Emri):",
    VIP4: "Maker (Limit Emri):",
    buyAmount: "Alım miktarı şundan yüksek olamaz",
    sellAmount: "Satış miktarı şundan yüksek olamaz",
    buyAmountMin: "Alınabilir bakiyeniz yetersiz",
    sellAmountMin: "Satılabilir bakiyeniz yetersiz",
};

const common = {
    wan: "10K", // Türkçede 'on bin' için kullanılır, ancak finansal bağlamda 10^4 anlamında "wan" yerine "10K" kullanımı yaygındır.
    qian: "Bin",
    yi: "100M", // Türkçede 'yüz milyon' için kullanılır, ancak finansal bağlamda 10^8 anlamında "yi" yerine "100M" kullanımı yaygındır.
};
const transferDialog = {
    划转: "Transfer",
    资金互转: "Karşılıklı Fon Transferi",
    币币账户: "Coin-Coin Hesabı",
    买币账户: "Coin Satın Alma Hesabı",
    已冻结: "Donduruldu",
    合约账户: "Vadeli İşlem Hesabı",
    未开通: "Açılmadı",
    杠杆账户: "Kaldıraç Hesabı",
    币贷宝账户: "Coin Kredi Hesabı",
    从: "Kimden",
    转至: "Kime",
    币种: "Token",
    数量: "Miktar",
    全部: "Tümü",
    用户未归还借贷的情况下: "Kullanıcı kredi borcunu ödemediği durumda, risk oranı %200'den büyük olan fonlar transfer edilebilir",
    可划转: "Transfer Edilebilir",
    一阶: "1. Birinci Aşama",
    累计净划入: "Net Transfer Toplamı",
    可获得: "Kazanılabilir",
    泥码: "Çamur Kodu",
    二阶: "2. İkinci Aşama",
    您尚未完成实名认证: "Kimlik doğrulamanızı henüz tamamlamadınız",
    余额: "Bakiye",
    立即划转: "Hemen Transfer Et",
    资产划转: "Varlık Transferi",
    用于维持现有仓位的保证金: "Mevcut pozisyonları sürdürmek için kullanılan teminat",
    归还数量: "Geri Ödeme Miktarı",
    您的币贷宝账户尚未开通: "Coin Kredi hesabınız henüz açılmadı, lütfen önce açın",
    请输入正确的数量: "Lütfen doğru miktarı girin",
    划转金额不能为: "Transfer tutarı 0 olamaz",
    账户可用余额不足: "Hesap kullanılabilir bakiyesi yetersiz",
    划转失败: "Transfer başarısız",
    划转成功: "Transfer başarılı",
    本次划转未能获得泥码: "Maalesef, çamur kodu etkinliği sona erdi, bu transfer çamur kodu kazanamadı",
    您只需再向合约账户划转: "Vadeli işlem hesabına sadece [*] USDT daha transfer ederek [**] USDT çamur kodu kazanabilirsiniz",
    您向合约账户: "Vadeli işlem hesabına<br/>net toplam [*]USDT üzeri transfer ettiğinizde, kazanın",
    请输入划转数量: "Lütfen transfer miktarını girin",
};
export {
    state,
    subheader,
    purchase,
    purchaseCondition,
    historyProject,
    alipay,
    projectDetails,
    purchaseOver,
    myPurchase,
    mHeader,
    res,
    addContent,
    hyy,
    trading,
    common,
    transferDialog,
};


// WEBPACK FOOTER //
// ./src/i18n/lang/tr.js